import { acceptHMRUpdate, defineStore } from 'pinia';

/** @import { PedidoVenta } from '@erpagroapp/types' */

export const useAppOrdersStore = defineStore('appOrders', {
  state: () => ({
    newOrder: [], // pedido desde 0
    dataClient: null, // datos el cliente actual
    /** @type {PedidoVenta | null} */
    actualOrder: null, // datos del pedido actual
    initStateOrder: null,
    salesOrderLine: null, // datos de la linea seleccionada
    mixedOrderLines: null, // guardamos aqui las lineas del pale mixto mientras que no se guarde el pale
    estadoPedidoCopiado: false,
    estadoLineaCopiada: false,
    estadoLineaEditada: false,
    estadoLineaMixtaEdit: false,
    salesOrderListByday: null, // listado con la lista de pedidos del dia
    filters: null,
  }),

  getters: {
    getDataClient: (state) => (
      state.dataClient != null ? state.dataClient : null
    ),
    getActualOrder: (state) => (
      state.actualOrder != null ? state.actualOrder : null
    ),
    getInitStateOrder: (state) => (
      state.initStateOrder != null ? state.initStateOrder : null
    ),
    getSalesOrderLine: (state) => (
      state.salesOrderLine != null ? state.salesOrderLine : null
    ),
    getSalesOrderListByday: (state) => (
      state.salesOrderListByday != null ? state.salesOrderListByday : null
    ),
  },

  actions: {
    resetValuesApp() {
      this.estadoPedidoCopiado = false;
      this.estadoLineaCopiada = false;
      this.dataClient = null;
      this.newOrder = [];
      this.actualOrder = null;
      this.mixedOrderLines = null;
      this.initStateOrder = null;
    },

    // para añadir nueva linea al pedido
    addNewOrder(value) {
      this.newOrder.push(value);
    },

    updateOrder(value) {
      this.newOrder.splice(value.Posicion, 1, value.Pedido);
    },
  },

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useAppOrdersStore, import.meta.webpackHot));
}
